import type { FCC } from '../types';
import { LanguageSelectorContext } from '../context/LanguageSelectorContext';
import { useEffect, useState } from 'react';

export const LanguageSelectorProvider: FCC = ({ children }) => {
    
    const selectableLanguages = ['en', 'fr'];

    const [selectedLanguage] = useState<string>(() => {
        const savedLanguage = localStorage.getItem('mrs2-selectedLanguage') ?? 'en';

        // Return the saved language or default to 'en'
        // Ensure the saved language is one of the selectable languages
        // If not, default to 'en'
        if (selectableLanguages.includes(savedLanguage)) {
            return savedLanguage;
        } else {
            saveLanguageToBrowser('en');
            return 'en';
        }
    });
    
    // Save the selected language to localStorage
    const saveLanguageToBrowser = (language: string) => {
        localStorage.setItem('mrs2-selectedLanguage', language);
    };

    return (
        <LanguageSelectorContext.Provider
            value={{
                selectedLanguage: selectedLanguage,
                setSelectedLanguage: (language: string) => {
                    saveLanguageToBrowser(language); // Save to localStorage
                },
            }}
        >
            {children}
        </LanguageSelectorContext.Provider>
    );
};